import { Parameter } from '@/enums/Parameter'

interface ParameterData {
  parameter: Parameter
  translationUnitKey: string | null
}

export const defaultParametersUnits: ParameterData[] = [
  {
    parameter: Parameter.HeartRate,
    translationUnitKey: '1/min'
  },
  {
    parameter: Parameter.OxygenSaturation,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.OxygenSaturationSPO2,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.RespiratoryRate,
    translationUnitKey: '1/min'
  },
  {
    parameter: Parameter.Hemoglobin,
    translationUnitKey: 'g/dl'
  },
  {
    parameter: Parameter.GFR,
    translationUnitKey: 'ml/min/1,73m²'
  },
  {
    parameter: Parameter.SystolicArterialPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.DiastolicArterialPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.MeanArterialPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.SystolicBloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.DiastolicBloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.MeanBloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.Potassium,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Temperature,
    translationUnitKey: '°C'
  },
  {
    parameter: Parameter.InvasiveBloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.NonInvasiveBloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.MortalityRate,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.BloodPressure,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.AnionGap,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.BaseExcess,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Bicarbonate,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Calcium,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Chloride,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.DefaultBicarbonate,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Carboxyhemoglobin,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.DeoxygenatedHemoglobinHHB,
    translationUnitKey: 'g/dl/%'
  },
  {
    parameter: Parameter.DeoxygenatedHemoglobinFHHB,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Methemoglobin,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Oxyhemoglobin,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Glucose,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.Sodium,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.PartialPressurePCO2,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.PartialPressurePO2,
    translationUnitKey: 'mmHg'
  },
  {
    parameter: Parameter.PackedCellVolume,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.OxygenSaturationSO2,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.TotalHemoglobin,
    translationUnitKey: 'g/dl'
  },
  {
    parameter: Parameter.Alat,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Albumin,
    translationUnitKey: 'g/dl'
  },
  {
    parameter: Parameter.AlkalinePhosphatase,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Asat,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.AntithrombinIIIActivity,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Basophilgranulocyte,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.Bilirubin,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.BilirubinOverall,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.CreatineKinase,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.CK_MB,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Creatinine,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.Crp,
    translationUnitKey: 'mg/l'
  },
  {
    parameter: Parameter.EosinophilGranulocyte,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.Erythrocyte,
    translationUnitKey: 'Mio/µl'
  },
  {
    parameter: Parameter.Ferritin,
    translationUnitKey: 'ng/ml'
  },
  {
    parameter: Parameter.GGT,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Urea,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.UO,
    translationUnitKey: 'mL/24H'
  },
  {
    parameter: Parameter.UreaNitrogen,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.HBA1C,
    translationUnitKey: 'mmol/mol'
  },
  {
    parameter: Parameter.Hco3std,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Hematocrit,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Interleukin6,
    translationUnitKey: 'pg/ml'
  },
  {
    parameter: Parameter.INR,
    translationUnitKey: null
  },
  {
    parameter: Parameter.LDH,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Leukocyte,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.Lipase,
    translationUnitKey: 'U/l'
  },
  {
    parameter: Parameter.Lymphocyte,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.Mch,
    translationUnitKey: 'pg'
  },
  {
    parameter: Parameter.Mchc,
    translationUnitKey: 'g/dl'
  },
  {
    parameter: Parameter.Mcv,
    translationUnitKey: 'fl'
  },
  {
    parameter: Parameter.Magnesium,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Monocyte,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.NeutrophilGranulocytes,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.Procalcitonin,
    translationUnitKey: 'ng/ml'
  },
  {
    parameter: Parameter.PartialThromboplastinTime,
    translationUnitKey: 's'
  },
  {
    parameter: Parameter.Quick,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.Lactate,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.SerumLactate,
    translationUnitKey: 'mmol/l'
  },
  {
    parameter: Parameter.Thrombocytes,
    translationUnitKey: 'Tsd/µl'
  },
  {
    parameter: Parameter.TotalProtein,
    translationUnitKey: 'g/dl'
  },
  {
    parameter: Parameter.Triglycerides,
    translationUnitKey: 'mg/dl'
  },
  {
    parameter: Parameter.Troponin,
    translationUnitKey: 'ng/ml'
  },
  {
    parameter: Parameter.TroponinI,
    translationUnitKey: 'ng/ml'
  },
  {
    parameter: Parameter.TroponinThs,
    translationUnitKey: 'ng/ml'
  },
  {
    parameter: Parameter.TSH,
    translationUnitKey: 'mU/l'
  },
  {
    parameter: Parameter.RDW,
    translationUnitKey: '%'
  },
  {
    parameter: Parameter.PH,
    translationUnitKey: null
  }
]
